<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 22.36 12.35"
  >
    <g id="Layer_2" data-name="Layer 2">
      <g id="Icon-Preview">
        <g class="cls-2">
          <g id="Group_1186" data-name="Group 1186">
            <path
              id="Path_444"
              data-name="Path 444"
              :fill="iconColor"
              d="M11.17,1.93A4.17,4.17,0,1,0,15.36,6.1a4,4,0,0,0-1.24-2.94,4,4,0,0,0-2.95-1.23m2.32,6.5A3.28,3.28,0,0,1,8.82,3.82l0,0a3.28,3.28,0,0,1,4.67,4.62l0,0"
              transform="translate(0 0)"
            />
            <path
              id="Path_445"
              data-name="Path 445"
              :fill="iconColor"
              d="M19.39,3.14A17.34,17.34,0,0,0,16.5,1.32a14,14,0,0,0-2.95-1,11.94,11.94,0,0,0-3-.26A11.31,11.31,0,0,0,6.34,1,18.76,18.76,0,0,0,3.07,2.93,14.38,14.38,0,0,0,.94,4.85h0c-.68.74-.82.9-.84.93h0a.48.48,0,0,0-.1.29.53.53,0,0,0,.09.3A24.74,24.74,0,0,0,2.6,9a16.64,16.64,0,0,0,2.62,1.87A11.55,11.55,0,0,0,7.94,12a10.92,10.92,0,0,0,2.84.38,11.13,11.13,0,0,0,4.49-.91,19.37,19.37,0,0,0,3.59-2,17,17,0,0,0,2.44-2l1-1a.48.48,0,0,0,.08-.31.42.42,0,0,0-.1-.3,24.4,24.4,0,0,0-2.86-2.61m1.8,3.05c-.29.31-.76.77-1.39,1.35A17.27,17.27,0,0,1,17.48,9.3a16.73,16.73,0,0,1-3.06,1.51,10.29,10.29,0,0,1-3.63.64h0a9.56,9.56,0,0,1-2.55-.35,10.85,10.85,0,0,1-2.45-1A13.8,13.8,0,0,1,3.38,8.47,20.72,20.72,0,0,1,1.1,6.16L1,6.06,1.1,6c.26-.29.68-.71,1.23-1.25h0A16.24,16.24,0,0,1,7.22,1.65,10.54,10.54,0,0,1,10.63.9a11,11,0,0,1,2.69.25A11.85,11.85,0,0,1,16,2.06a16.22,16.22,0,0,1,2.63,1.63A21.45,21.45,0,0,1,21.19,6l.1.1Z"
              transform="translate(0 0)"
            />
          </g>
        </g>
      </g>
    </g>
  </svg>
</template>

<script>
  import { computed } from 'vue'
  import { useTheme } from 'vuetify'

  export default {
    name: 'EyeIcon',
    setup() {
      const theme = useTheme()
      const iconColor = computed(() =>
        theme.global.current.value.dark ? '#CECECE' : '#50514e'
      )

      return {
        iconColor,
      }
    },
  }
</script>

<style scoped>
  svg {
    width: 22.36px;
    height: 12.35px;
  }
  svg,
  svg path {
    transition: 0.4s ease;
  }
  svg:hover {
    transform: scale(1.2);
  }
  /* svg:hover path {
        fill: #a5d867 !important;
    } */
</style>
